import React, { useMemo, useState } from "react";
import { Box } from "@mui/material";
import {
  myTimesheetEmplyeeRequestsTable,
  myTimesheetEmplyeeRequestsTableIsMobile,
} from "my-timesheet/configs/table-defs";
import { OcDataTable } from "oc/components";
import { useOcTableState } from "oc/hooks";

interface MyTimesheetTableContainerProps {
  data: any[];
  onShowRequest?: (id: string) => void;
  isMobile?: boolean;
  tableId: string;
}

export const MyTimesheetMyTimesheetTableContainer = ({
  data,
  onShowRequest,
  isMobile,
  tableId,
}: MyTimesheetTableContainerProps) => {
  const [selectedRowId, setSelectedRowId] = useState<string | number | undefined>(undefined);

  const defaultTableState = useMemo(
    () => ({
      sortDirection: "desc" as const,
      page: 1,
      pageSize: 5,
    }),
    []
  );

  const [tableData, setTableData] = useOcTableState(tableId, defaultTableState);

  const tableRows = {
    rows: data || [],
    total: data?.length || 0,
  };

  const tableDef = isMobile
    ? myTimesheetEmplyeeRequestsTableIsMobile
    : myTimesheetEmplyeeRequestsTable;

  const filteredTableDef = useMemo(
    () => ({
      id: tableDef?.id,
      columns: myTimesheetEmplyeeRequestsTable?.columns?.filter(
        (column) =>
          !myTimesheetEmplyeeRequestsTableIsMobile?.columns?.some(
            (mobileColumn) => mobileColumn?.id === column?.id
          )
      ),
    }),
    [tableDef]
  );

  const handleRowSelection = ({ row }: { row: any }) => {
    if (onShowRequest) onShowRequest(row._id);
  };

  const onSelectRow = (row: any) => {
    if (row?.state === "inProgress") return;

    if (isMobile) {
      setSelectedRowId(selectedRowId === row?._id ? undefined : row?._id);
    } else {
      handleRowSelection({ row });
    }
  };
  return (
    <Box>
      <OcDataTable
        data={tableRows}
        tableId={tableId}
        tableDef={tableDef}
        tableData={tableData}
        setTableData={setTableData}
        onSelectRow={onSelectRow}
        pagination={true}
        selectedRowId={selectedRowId}
        filteredTableDef={filteredTableDef}
        handleMoreButton={handleRowSelection}
        localPaging={true}
      />
    </Box>
  );
};

export default MyTimesheetMyTimesheetTableContainer;
